import { parseAmount } from '@shared/lib'
import { Amount } from '@root/api/ump-ewallet'

export const parseAmountInfo = (amount: Amount | undefined) => {
  if (!amount) {
    return { base: '', fee: '', total: '' }
  }

  const { base, fee, total } = amount

  const parsedBaseAmount = parseAmount(base)
  const parsedFeeAmount = parseAmount(fee || '')
  const parsedTotalAmount = parseAmount(total)

  return { base: parsedBaseAmount, fee: parsedFeeAmount, total: parsedTotalAmount }
}
